module.exports = "https://ssr-releases-cdn.paperlesspost.com/_next/static/images/tile_gamenight-d19fdb92ed651c4f0510d4c8fb957f6c.jpg";